/*
  Running page card outside the Running grid: every ul.rc-cards printed with snippets/rc-card.liquid
  (homepage tabs, product rows, Pairs well with, Recently Viewed). Loaded with defer by
  snippets/rc-card-assets.liquid; several sections can print the tag and the guard below runs it once.

  - Hover photos: fine pointers only, after window load, near the viewport.
  - Quick add: the desktop size strip and the phone + sheet, through RC_CART.add (else a POST to cart/add.js).
  - Notify me: a Shopify customer form in a sheet, then a toast when Shopify sends the shopper back.
  - Rails (div[data-rcx-rail]): the product row's bar, chevrons, drag and phone pairs.

  Lifted from sections/section-rc-collection-v3.liquid (card model 1753-1766, sheets 2207-2269, quick add
  2399-2490, Notify me 2492-2555 and 2586-2591, hover photos 2650-2658) and from the row script in
  sections/section-rc-product-row.liquid (521-674). Keep in step with both.

  The card model is read from the li's data attributes at click time, so cards added later (Recently
  Viewed, the theme editor) need no init list. Cards inside the Running grid ([id^="RcColl--"]) belong
  to that section's own script and are skipped here, so nothing is added or opened twice.

  Markup this script expects (snippets/rc-card-assets.liquid and snippets/rc-card-rail-nav.liquid):
  - template[data-rcx-sheets] holding #RcxQA (quick add sheet), #RcxNF (Notify me sheet with the
    customer form #RcxNotifyForm) and #RcxToast, with v3's inner class names and data hooks.
  - Each list: ul.rc-cards[data-rcx-src="home|row|pairs|recent|article|article-end"]; analytics carry it as src.
    A list with data-rcx-ev="<name>" also sends <name>_quick_add next to card_quick_add (the blog article
    rows, sections/section-rc-article-shop.liquid, send article_quick_add).
  - Each rail: [data-rcx-rail] holding the list (.rcx-rail__list) and the nav, whose parts are
    [data-rcx-nav], [data-rcx-bar], [data-rcx-thumb] and [data-rcx-step="-1|1"] (the row's
    data-rcpr-* names are accepted too).
*/
(function () {
  'use strict';
  if (window.RCX) return;
  var RCX = window.RCX = { version: 1 };

  var d = document;
  var SKIP = '[id^="RcColl--"]';
  /* low_stock_at is 5 on every line preset in snippets/rc-card.liquid */
  var LOW = 5;
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var PHONE = window.matchMedia('(max-width: 749px)');
  var WIDE = window.matchMedia('(min-width: 750px)');
  var SPIN = '<span class="rcc-spin rcx-spin" aria-hidden="true"></span>';
  var TICK = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.5" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
  var HOVER = '.rcc-card__hover[data-src]';

  /* the snippet's inline script sets this first; this covers a page where it did not run */
  try { d.documentElement.classList.add('rcx-js'); } catch (e) {}

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function $(s, el) { return (el || d).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || d).querySelectorAll(s)); }
  function closest(n, s) { return n && n.closest ? n.closest(s) : null; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function andList(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function focusQuiet(el) { if (el) { try { el.focus({ preventScroll: true }); } catch (e) {} } }
  function track(n, p) { try { if (window.rcEvent) window.rcEvent(n, p || {}); } catch (e) {} }
  /* one of ours: inside a .rc-cards list and not inside the Running grid */
  function ours(n) { return !!closest(n, '.rc-cards') && !closest(n, SKIP); }
  function srcOf(n) { var l = closest(n, '[data-rcx-src]'); return l ? l.getAttribute('data-rcx-src') || '' : ''; }
  function evOf(n) { var l = closest(n, '[data-rcx-ev]'); return l ? l.getAttribute('data-rcx-ev') || '' : ''; }
  function marker() {
    var set = window.WeakSet ? new WeakSet() : null, key = '__rcx' + Math.random().toString(36).slice(2);
    return function (el) {
      if (set) { if (set.has(el)) return false; set.add(el); return true; }
      if (el[key]) return false; el[key] = 1; return true;
    };
  }
  var firstList = marker(), firstRail = marker();

  /* card model, read from the li when clicked (v3 1753-1766 without the sort and filter fields) */
  function isBuy(z) { return z.st === 1 || z.st === 2; }
  function sizeOf(c, s) { for (var i = 0; i < c.sz.length; i++) if (c.sz[i].a === s) return c.sz[i]; return null; }
  function model(li) {
    var a = li.dataset, link = $('.rcc-card__link', li), rs = $('.rcc-st--restock', li);
    /* the Black Friday preorder sizes (data-po-bf, variant ids, during and after only) */
    var pbf = a.poBf ? ' ' + a.poBf + ' ' : '';
    return {
      el: li, handle: a.handle || '', title: a.title || '', name: a.colorName || '', state: a.state || '',
      /* p: the size's own price in cents on poster cards (rc-colorway-sizes-v3 labels), else 0.
         bf: a Black Friday preorder size, shown like an in-stock size */
      sz: a.sizes ? a.sizes.split(',').map(function (t) { var p = t.split(':'); return { a: p[0], st: +p[1], q: +p[2], v: +p[3], p: +p[4] || 0, bf: !!pbf && p[1] === '2' && pbf.indexOf(' ' + p[3] + ' ') > -1 }; }) : [],
      price: +a.price || 0, compare: +a.compare || 0, priceF: a.priceF || '', compareF: a.compareF || '',
      restock: a.restock === '1', bundle: a.bundle === '1', dv: +a.dv || 0, img: a.img || '', po: a.po || '',
      url: link ? link.getAttribute('href') || '' : '',
      /* the card's own restock line (restock_card_text of its line) stands in for v3's cfg.restockText */
      rt: rs ? rs.textContent.replace(/\s+/g, ' ').trim() : '',
      src: srcOf(li), ev: evOf(li)
    };
  }

  /* quick add (v3 2399-2426), never disabling the focused control. No Buy 2 progress here. */
  function addToBag(c, z) {
    var later = !!z && z.st === 2;
    /* back order flags only for a size at 0 that keeps selling: a Black Friday preorder size still has stock (QTY above 0) */
    var bo = later && !(z.q > 0);
    var item = { id: z ? z.v : c.dv, quantity: 1, properties: { _rc_avail: bo ? 'unavailable' : 'in', _rc_backorder: bo ? 'true' : 'false' } };
    /* a preorder size: the order shows Preorder: Ships by Dec 15 (the bag reads it too) */
    if (later && c.po) item.properties.Preorder = 'Ships by ' + c.po;
    var C = window.RC_CART, p;
    if (!item.id) p = Promise.reject(new Error('no variant'));
    else if (C && C.add) { try { p = Promise.resolve(C.add([item])); } catch (e) { p = Promise.reject(e); } }
    else p = fetch(root() + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (b) { if (!r.ok) { var er = new Error('HTTP ' + r.status); er.desc = b.description || b.message || ''; throw er; } return b; }); });
    function sent(ok) {
      var pr = { h: c.handle, s: z ? z.a : '', ok: ok, src: c.src, po: later && c.po ? 1 : 0 };
      track('card_quick_add', pr);
      if (c.ev) track(c.ev + '_quick_add', pr);
    }
    return p.then(function () { sent(1); }, function (err) { sent(0); throw err; });
  }
  function openCart() { var C = window.RC_CART; if (C && C.open) { try { C.open(); } catch (e) {} } else location.href = root() + 'cart'; }
  function errText(err) { return (err && err.desc) ? String(err.desc) : 'Could not add that. Please try again.'; }
  function cardErr(c, err) {
    var er = $('.rcc-card__err', c.el); if (!er) return;
    er.innerHTML = esc(errText(err)) + (c.url ? ' <a href="' + esc(c.url) + '">View details</a>' : '');
    er.hidden = false;
  }
  function stripAdd(btn) {
    if (btn.disabled) return;
    var strip = btn.parentNode, li = closest(btn, '.rcc-card');
    if (!li || strip.getAttribute('data-busy')) return;
    var c = model(li), s = btn.getAttribute('data-s'), z = s ? sizeOf(c, s) : null;
    /* a size button with no matching size would add the default variant instead: say so and stop */
    if (s && !z) { cardErr(c, null); return; }
    var all = $$('.rcc-strip__b', strip), was = btn.innerHTML, er = $('.rcc-card__err', li);
    strip.setAttribute('data-busy', '1'); strip.setAttribute('aria-busy', 'true');
    all.forEach(function (b) { if (!b.disabled) b.setAttribute('aria-disabled', 'true'); });
    btn.classList.add('is-busy'); btn.innerHTML = SPIN + '<span class="rcc-sr">Adding</span>'; if (er) er.hidden = true;
    function restore() { btn.classList.remove('is-busy', 'is-done'); btn.innerHTML = was; strip.removeAttribute('data-busy'); strip.removeAttribute('aria-busy'); all.forEach(function (b) { b.removeAttribute('aria-disabled'); }); }
    addToBag(c, z).then(function () {
      btn.classList.remove('is-busy'); btn.classList.add('is-done');
      btn.innerHTML = TICK + '<span class="rcc-sr">Added</span>';
      openCart(); setTimeout(restore, 1200);
    }, function (err) { restore(); cardErr(c, err); focusQuiet(btn); });
  }
  /* the strip label names the size under the pointer: "L ships later", "M: 2 left" (v3 2427-2433) */
  function stripNote(b, on) { var l = $('.rcc-strip__l', b.parentNode); if (!l) return; var t = on ? b.getAttribute('data-note') : ''; setText(l, t || 'Quick add'); l.classList.toggle('is-note', !!t); }
  function stripB(e) { var b = closest(e.target, '.rcc-strip__b'); return b && ours(b) ? b : null; }
  d.addEventListener('mouseover', function (e) { var b = stripB(e); if (b) stripNote(b, true); });
  d.addEventListener('mouseout', function (e) { var b = stripB(e); if (b && !(e.relatedTarget && b.contains(e.relatedTarget))) stripNote(b, false); });
  d.addEventListener('focusin', function (e) { var b = stripB(e); if (b) stripNote(b, true); });
  d.addEventListener('focusout', function (e) { var b = stripB(e); if (b) stripNote(b, false); });

  /* sheets: cloned once into body from the first template[data-rcx-sheets]. Copies printed by other
     sections stay inert inside their templates. */
  var qSheet = null, nfSheet = null, toastEl = null, got = false;
  function sheets() {
    if (got) return true;
    var tpl = $('template[data-rcx-sheets]');
    if (!tpl || !tpl.content || !d.body) return false;
    got = true;
    var frag = d.importNode(tpl.content, true);
    function take(id, alt) {
      var el = d.getElementById(id);
      if (!el) { el = frag.querySelector('#' + id) || frag.querySelector(alt); if (el) d.body.appendChild(el); }
      return el || null;
    }
    qSheet = take('RcxQA', '[data-rcx-sheet="qa"]');
    nfSheet = take('RcxNF', '[data-rcx-sheet="nf"]');
    toastEl = take('RcxToast', '[data-rcx-toast]');
    bindSheet(qSheet); bindSheet(nfSheet);
    if (qSheet) bindQA();
    if (nfSheet) bindNF();
    if (toastEl) toastEl.addEventListener('click', function (e) { if (closest(e.target, '.rcc-toast__x')) hideToast(); });
    return true;
  }

  /* sheet manager (v3 2207-2269 without the filter and size guide parts): history entry (key rcx),
     scroll lock, Escape, Tab trap, Back, focus back to the opener */
  var sheet = null, opener = null, pushed = false, after = null, prevOverflow = '', closing = false, closeT = 0;
  if (history.state && history.state.rcx === 'sheet') { try { history.replaceState(null, ''); } catch (e) {} }
  function focusables(sh) { return $$('button:not([disabled]):not([hidden]), a[href], select, input:not([disabled]):not([type="hidden"]), textarea, [tabindex="0"]', sh).filter(function (x) { return x.tabIndex >= 0 && x.offsetParent !== null; }); }
  function onSheetKey(e) {
    if (!sheet) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(sheet); if (!f.length) return;
    var i = f.indexOf(d.activeElement);
    if (i < 0) { e.preventDefault(); (e.shiftKey ? f[f.length - 1] : f[0]).focus(); }
    else if (e.shiftKey && i === 0) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
  }
  function bindSheet(sh) {
    if (!sh) return;
    sh.hidden = true;
    sh.addEventListener('click', function (e) {
      if (closest(e.target, '[data-close]')) { closeSheet(); return; }
      /* a link out of an open sheet: pop the sheet's history entry first, so Back leaves the page once */
      var a = closest(e.target, 'a[href]');
      if (a && pushed && !e.defaultPrevented && e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && a.getAttribute('target') !== '_blank' && a.getAttribute('href').charAt(0) !== '#') {
        e.preventDefault(); var href = a.href; after = function () { location.href = href; }; closeSheet();
      }
    });
  }
  function openSheet(sh, from, kind, src) {
    if (sheet) return;
    sheet = sh; opener = from; sh.hidden = false; closing = false;
    prevOverflow = d.documentElement.style.overflow; d.documentElement.style.overflow = 'hidden';
    if (!DESIGN) { try { history.pushState({ rcx: 'sheet' }, ''); pushed = true; } catch (e) { pushed = false; } }
    void sh.offsetWidth; sh.classList.add('is-open');
    if (from && from.hasAttribute('aria-expanded')) from.setAttribute('aria-expanded', 'true');
    d.addEventListener('keydown', onSheetKey);
    focusQuiet($('[tabindex="-1"]:not([role="dialog"])', sh));
    track('card_sheet_open', { kind: kind, src: src || '' });
  }
  function closeSheet() {
    if (!sheet || closing) return;
    if (pushed) {
      closing = true;
      try { history.back(); } catch (e) {}
      closeT = setTimeout(function () { if (closing && sheet) { pushed = false; finishClose(); } }, 700);
    } else finishClose();
  }
  function finishClose() {
    var sh = sheet; if (!sh) return;
    sheet = null; pushed = false; closing = false; clearTimeout(closeT);
    d.removeEventListener('keydown', onSheetKey);
    sh.classList.remove('is-open');
    d.documentElement.style.overflow = prevOverflow;
    setTimeout(function () { if (sheet !== sh) sh.hidden = true; }, RM.matches ? 0 : 260);
    if (opener) { if (opener.hasAttribute('aria-expanded')) opener.setAttribute('aria-expanded', 'false'); focusQuiet(opener); }
    var fn = after; after = null; if (fn) fn();
  }
  window.addEventListener('popstate', function () { if (sheet && pushed) { pushed = false; finishClose(); } });

  /* quick add sheet for the phone + button (v3 2435-2490, without the size filter) */
  var qc = null, qz = null, qBusy = false, qAdd = null, qErr = null, qSizes = null, qSoon = null;
  function bindQA() {
    qAdd = $('.rcc-qa__add', qSheet); qErr = $('.rcc-qa__err', qSheet); qSizes = $('.rcc-qa__sizes', qSheet); qSoon = $('.rcc-qa__soon', qSheet);
    if (!qAdd || !qErr || !qSizes || !qSoon) { qSheet = null; return; }
    qSizes.addEventListener('click', function (e) { var b = closest(e.target, '.rcc-qsz'); if (!b || b.disabled || qBusy || !qc) return; qz = sizeOf(qc, b.getAttribute('data-s')); paintQA(); });
    qSizes.addEventListener('keydown', function (e) {
      var k = e.key; if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(k) < 0 || !qc) return;
      e.preventDefault();
      var r = $$('.rcc-qsz', qSizes).filter(function (b) { return !b.disabled; }); if (!r.length) return;
      var i = r.indexOf(d.activeElement), step = (k === 'ArrowRight' || k === 'ArrowDown') ? 1 : -1;
      var nb = r[(i + step + r.length) % r.length]; qz = sizeOf(qc, nb.getAttribute('data-s')); paintQA(); nb.focus();
    });
    qAdd.addEventListener('click', function () {
      if (!qc || qBusy || qAdd.getAttribute('aria-disabled') === 'true') return;
      var c = qc, z = qz; qBusy = true;
      qAdd.setAttribute('aria-disabled', 'true'); qAdd.classList.add('is-busy'); qAdd.innerHTML = SPIN + 'Adding'; qErr.hidden = true;
      addToBag(c, z).then(function () {
        qBusy = false; qAdd.innerHTML = TICK + 'Added';
        after = openCart; closeSheet();
      }, function (err) { qBusy = false; qErr.textContent = errText(err); qErr.hidden = false; paintQA(); focusQuiet(qAdd); });
    });
    qSheet.addEventListener('click', function (e) {
      if (!closest(e.target, '[data-qa-notify]') || !qc) return;
      var c = qc; after = function () { restockAlert(c, c.el.isConnected ? $('.rcc-plus', c.el) : null); }; closeSheet();
    });
  }
  function openQA(c, from) {
    if (sheet) return;
    qc = c; qz = null; qErr.hidden = true; qBusy = false;
    var im = $('.rcc-qa__img', qSheet); if (im) im.style.backgroundImage = c.img ? "url('" + c.img.replace(/'/g, '%27') + "')" : '';
    setText($('.rcc-qa__t', qSheet), c.title); setText($('.rcc-qa__c', qSheet), c.name);
    var bl = $('.rcc-card__bundle', c.el), qb = $('.rcc-qa__b', qSheet); if (qb) { setText(qb, bl ? bl.textContent : ''); qb.hidden = !bl; }
    var ql = $('.rcc-qa__link', qSheet); if (ql && c.url) ql.setAttribute('href', c.url);
    var avail = c.sz.filter(isBuy);
    if (avail.length === 1) qz = avail[0];
    qSizes.innerHTML = c.sz.map(function (z) {
      var soon = z.st === 0 && c.restock;
      /* a Black Friday preorder size gets no note, like an in-stock size (adding it still sets the Preorder property) */
      var sub = z.bf ? '' : z.st === 2 ? (c.po ? 'Preorder' : 'Ships later') : soon ? 'Back soon' : (z.st === 1 && z.q <= LOW ? z.q + ' left' : '');
      var nm = z.a + (z.st === 0 ? ', sold out' + (soon ? ', back soon' : '') : sub ? ', ' + sub.toLowerCase() : '');
      return '<button type="button" class="rcc-qsz' + (soon ? ' is-soon' : '') + '" role="radio" data-s="' + esc(z.a) + '" aria-checked="false" aria-label="' + esc(nm) + '"' + (z.st === 0 ? ' disabled' : '') + '><span class="rcc-qsz__l">' + esc(z.a) + '</span>' + (sub ? '<span class="rcc-qsz__n">' + sub + '</span>' : '') + '</button>';
    }).join('');
    var sh = qSizes.parentNode.querySelector('.rcc-fsec__t'); if (sh) sh.hidden = !c.sz.length;
    /* sold-out sizes: say so, and offer Notify me (restocking colors and plain sold-out sizes alike) */
    var outs = (c.restock || nfSheet) ? c.sz.filter(function (z) { return z.st === 0; }).map(function (z) { return z.a; }) : [];
    qSoon.hidden = !outs.length || !avail.length;
    if (outs.length) {
      var rt = String(c.rt || 'Back soon'), nb = $('[data-qa-notify]', qSoon);
      setText($('[data-soon-t]', qSoon), andList(outs) + ': ' + (c.restock ? rt.charAt(0).toLowerCase() + rt.slice(1) : 'sold out for now') + '.');
      if (nb) { nb.hidden = !nfSheet; nb.setAttribute('aria-label', 'Notify me when ' + andList(outs) + ' is back'); }
    }
    paintQA(); openSheet(qSheet, from, 'qa', c.src);
  }
  function paintQA() {
    var r = $$('.rcc-qsz', qSizes), first = r.filter(function (b) { return !b.disabled; })[0];
    r.forEach(function (b) { var on = !!qz && b.getAttribute('data-s') === qz.a; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on || (!qz && b === first) ? 0 : -1; });
    var ready = !!qz || !qc.sz.length;
    if (ready) qAdd.removeAttribute('aria-disabled'); else qAdd.setAttribute('aria-disabled', 'true');
    qAdd.classList.remove('is-busy');
    /* sizes with their own price (posters: 12x18 $30, 24x36 $45): the picked size's price, "From $30" before a pick */
    var zp = qz && qz.p > 0 && qz.p !== qc.price ? qz.p : 0;
    var vary = !qz && qc.sz.some(function (z) { return isBuy(z) && z.p > qc.price; }) && !qc.sz.some(function (z) { return isBuy(z) && z.p && z.p < qc.price; });
    var pe = $('.rcc-qa__p', qSheet); if (pe) pe.innerHTML = zp ? esc(money(zp)) : (vary ? 'From ' : '') + esc(qc.priceF || money(qc.price)) + (qc.compare > qc.price ? '<s>' + esc(qc.compareF || money(qc.compare)) + '</s>' : '');
    qAdd.textContent = ready ? 'Add to bag \u00b7 ' + (zp ? money(zp) : (qc.priceF || money(qc.price))) : 'Pick a size';
  }

  /* Notify me (v3 2492-2534): a Shopify customer form in a sheet. Sizes are the sold-out ones (all of
     them for a sold-out color); the tags and return_to are set on submit, then it posts as a normal form,
     never fetch, so Shopify can show its captcha page if it wants one. */
  var nfC = null, nfZ = '', nfLive = false, nfForm = null, nfSizes = null, nfErr = null, nfGo = null;
  function nfOuts(c) { return c.sz.filter(function (z) { return z.st === 0; }); }
  function bindNF() {
    nfForm = $('form', nfSheet); nfSizes = $('[data-nf-sizes]', nfSheet); nfErr = $('[data-nf-err]', nfSheet); nfGo = $('.rcc-nf__go', nfSheet);
    if (!nfForm || !nfSizes || !nfErr || !nfGo || !$('[data-nf-tags]', nfSheet) || !$('[data-nf-ret]', nfSheet)) { nfSheet = null; return; }
    nfSizes.addEventListener('click', function (e) { var b = closest(e.target, '.rcc-qsz'); if (!b) return; nfZ = b.getAttribute('data-s'); nfErr.hidden = true; paintNF(); });
    nfSizes.addEventListener('keydown', function (e) {
      var k = e.key; if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(k) < 0) return;
      e.preventDefault();
      var r = $$('.rcc-qsz', nfSizes); if (!r.length) return;
      var i = r.indexOf(d.activeElement), nb = r[(i + ((k === 'ArrowRight' || k === 'ArrowDown') ? 1 : -1) + r.length) % r.length];
      nfZ = nb.getAttribute('data-s'); paintNF(); nb.focus();
    });
    /* Shopify's storefront captcha script listens for this submit on the document, holds it for an hCaptcha
       token and submits again. So the first pass checks and fills the form, closes the sheet (its history
       entry goes first, so Back from the next page does not land on it), then requestSubmit() sends a
       second pass that is left alone. */
    nfForm.addEventListener('submit', function (e) {
      var c = nfC;
      if (nfLive) return;
      if (!c || nfGo.classList.contains('is-busy')) { e.preventDefault(); return; }
      if (nfOuts(c).length && !nfZ) { e.preventDefault(); nfErr.textContent = 'Pick a size first.'; nfErr.hidden = false; focusQuiet($('.rcc-qsz', nfSizes)); return; }
      var tags = ['restock-notify', 'restock-' + c.handle]; if (nfZ) tags.push('restock-size-' + nfZ.toLowerCase());
      $('[data-nf-tags]', nfSheet).value = tags.join(', ');
      var q = new URLSearchParams(location.search); q.delete('customer_posted'); q.set('customer_posted', 'true');
      $('[data-nf-ret]', nfSheet).value = location.pathname + '?' + q.toString().replace(/%2C/gi, ',');
      /* same key and shape as v3 (plus src), so whichever page the shopper lands on can name the item */
      try { sessionStorage.setItem('rcc_nf', JSON.stringify({ t: c.title + (c.name ? ', ' + c.name : ''), s: nfZ, at: Date.now(), src: c.src })); } catch (x) {}
      track('card_notify', { h: c.handle, s: nfZ, src: c.src });
      nfGo.classList.add('is-busy'); nfGo.setAttribute('aria-disabled', 'true'); nfGo.innerHTML = SPIN + 'Sending';
      if (pushed) { e.preventDefault(); e.stopPropagation(); after = function () { nfLive = true; if (nfForm.requestSubmit) nfForm.requestSubmit(); else nfForm.submit(); }; closeSheet(); }
      else nfLive = true;
    });
  }
  function openNF(c, from, pick) {
    if (sheet) return;
    var outs = nfOuts(c);
    nfC = c; nfLive = false; nfZ = pick && outs.some(function (z) { return z.a === pick; }) ? pick : (outs.length === 1 ? outs[0].a : '');
    var im = $('.rcc-qa__img', nfSheet); if (im) im.style.backgroundImage = c.img ? "url('" + c.img.replace(/'/g, '%27') + "')" : '';
    setText($('.rcc-qa__t', nfSheet), c.title); setText($('.rcc-qa__c', nfSheet), c.name);
    var w = $('[data-nf-szw]', nfSheet); if (w) w.hidden = !outs.length;
    nfSizes.innerHTML = outs.map(function (z) { return '<button type="button" class="rcc-qsz" role="radio" data-s="' + esc(z.a) + '" aria-checked="false"><span class="rcc-qsz__l">' + esc(z.a) + '</span></button>'; }).join('');
    nfErr.hidden = true; nfGo.classList.remove('is-busy'); nfGo.removeAttribute('aria-disabled'); nfGo.textContent = 'Email me when it\'s back';
    paintNF(); openSheet(nfSheet, from, 'nf', c.src);
  }
  function paintNF() { $$('.rcc-qsz', nfSizes).forEach(function (b, i) { var on = b.getAttribute('data-s') === nfZ; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on || (!nfZ && i === 0) ? 0 : -1; }); }
  /* restock_form_id is blank on every line, so Notify me is always this page's own sheet (v3 2586-2591) */
  function restockAlert(c, from, pick) {
    if (!c) return;
    track('card_restock_alert', { h: c.handle, src: c.src });
    if (sheets() && nfSheet) { openNF(c, from, pick); return; }
    if (c.url) location.href = c.url;
  }

  /* toast (v3 2536-2555) */
  function toast(html) {
    if (!toastEl) return;
    clearTimeout(toast.t); toastEl.classList.remove('is-out');
    toastEl.innerHTML = '<span class="rcc-toast__i" aria-hidden="true">' + TICK + '</span><span class="rcc-toast__t">' + html + '</span><button type="button" class="rcc-toast__x" aria-label="Dismiss"><svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.75"/></svg></button>';
    toast.t = setTimeout(hideToast, 9000);
  }
  function hideToast() { if (!toastEl || !toastEl.firstChild) return; toastEl.classList.add('is-out'); setTimeout(function () { toastEl.innerHTML = ''; toastEl.classList.remove('is-out'); }, RM.matches ? 0 : 220); }
  /* Shopify sends the shopper back with customer_posted=true. The Running grid shows its own toast, so
     this one stays quiet there. The theme's newsletter forms use the same flag, so this toast also needs
     this tab's Notify me record (rcc_nf) or the form's own hash, or a newsletter signup would read
     "We'll email you when it's back". */
  function returnToast() {
    var P; try { P = new URLSearchParams(location.search); } catch (x) { return; }
    if (P.get('customer_posted') !== 'true' || $(SKIP)) {
      /* Our form's hash with the flag already gone: the Running grid or a sold-out product page's own Notify me
         (snippets/rc-pdp-notify) answered it first, or Shopify sent the shopper back without posting. Drop the hash,
         and off the Running page the record too, so a later newsletter signup is not read as this Notify me. */
      if (/^#RcxNotifyForm/.test(location.hash)) {
        if (!$(SKIP)) { try { sessionStorage.removeItem('rcc_nf'); } catch (x) {} }
        try { history.replaceState(history.state, '', location.pathname + location.search); } catch (x) {}
      }
      return;
    }
    var nfi = null; try { nfi = JSON.parse(sessionStorage.getItem('rcc_nf') || 'null'); } catch (x) {}
    if (!nfi || !(Date.now() - nfi.at < 3600000)) nfi = null;
    if (!nfi && !/^#RcxNotifyForm/.test(location.hash)) return;
    try { sessionStorage.removeItem('rcc_nf'); } catch (x) {}
    if (!toastEl) return;
    try { var cu = new URL(location.href); cu.searchParams.delete('customer_posted'); if (/^#(RcxNotifyForm|contact_form)/.test(cu.hash)) cu.hash = ''; history.replaceState(history.state, '', cu.pathname + cu.search.replace(/%2C/gi, ',') + cu.hash); } catch (x) {}
    setTimeout(function () { toast('<b>You\'re on the list</b>We\'ll email you when ' + (nfi ? esc(nfi.t) + (nfi.s ? ' in ' + esc(nfi.s) : '') + ' is' : 'it\'s') + ' back.'); }, 500);
    track('card_notify_back', { s: (nfi && nfi.s) || '', src: (nfi && nfi.src) || '' });
  }

  /* one click handler for every card list on the page */
  d.addEventListener('click', function (e) {
    var b = closest(e.target, 'button'), li;
    if (!b || !ours(b) || !(li = closest(b, '.rcc-card'))) return;
    if (b.classList.contains('rcc-strip__b')) { e.preventDefault(); stripAdd(b); return; }
    if (b.classList.contains('rcc-plus')) {
      var c = model(li);
      if (sheets() && qSheet) openQA(c, b); else if (c.url) location.href = c.url;
      return;
    }
    if (b.classList.contains('rcc-card__alert')) restockAlert(model(li), b);
  });

  /* hover photos (v3 2650-2658): fine pointers only, after window load, through an IntersectionObserver
     with a 400px margin. sizes is the card's rendered width. Cards hidden in a closed tab or scrolled out
     of a rail never intersect, so they load when they show; a pointer over a card loads its photo at once. */
  var hoverOn = false, io = null;
  function hoverSizes(i) {
    var box = i.parentNode, w = box ? box.clientWidth : 0;
    return w > 0 ? w + 'px' : '(min-width: 1280px) 25vw, (min-width: 750px) 33vw, 50vw';
  }
  function loadHover(i) {
    if (!i.hasAttribute('data-src')) return;
    if (io) io.unobserve(i);
    i.addEventListener('load', function () { i.classList.add('is-ready'); }, { once: true });
    i.sizes = hoverSizes(i);
    var ss = i.getAttribute('data-srcset'); if (ss) i.srcset = ss;
    i.src = i.getAttribute('data-src'); i.removeAttribute('data-src');
  }
  function watchHovers(n) {
    if (!hoverOn || !n || (n !== d && n.nodeType !== 1)) return;
    var imgs = (n.matches && n.matches(HOVER)) ? [n] : $$(HOVER, n);
    imgs.forEach(function (i) { if (!ours(i)) return; if (io) io.observe(i); else loadHover(i); });
  }
  function startHovers() {
    if (hoverOn || !FINE.matches) return;
    hoverOn = true;
    if ('IntersectionObserver' in window) io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) loadHover(en.target); }); }, { rootMargin: '400px 0px' });
    watchHovers(d);
  }
  d.addEventListener('pointerover', function (e) {
    if (!hoverOn) return;
    var li = closest(e.target, '.rcc-card'); if (!li || !ours(li)) return;
    var i = $(HOVER, li); if (i) loadHover(i);
  }, { passive: true });
  /* each list catches cards added later (Recently Viewed, the Pairs shuffle) */
  function watchList(ul) {
    if (closest(ul, SKIP) || !firstList(ul) || !window.MutationObserver) return;
    new MutationObserver(function (ms) { ms.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, watchHovers); }); }).observe(ul, { childList: true });
  }

  /* rail controller (section-rc-product-row 521-674) for every [data-rcx-rail]. Cards are looked up on
     each use, never kept from init, and a MutationObserver and a ResizeObserver repaint the bar. */
  var NAV = '[data-rcx-nav],[data-rcpr-nav]', BAR = '[data-rcx-bar],[data-rcpr-bar]', THUMB = '[data-rcx-thumb],[data-rcpr-thumb]', STEP = '[data-rcx-step],[data-rcpr-step]';
  function dirOf(b) { return parseInt(b.getAttribute('data-rcx-step') || b.getAttribute('data-rcpr-step'), 10) || 0; }
  function initRail(rail) {
    if (closest(rail, SKIP)) return;
    var list = rail.classList.contains('rc-cards') ? rail : ($('.rcx-rail__list', rail) || $('.rc-cards', rail));
    var nav = $(NAV, rail), bar = $(BAR, rail), thumb = $(THUMB, rail), prev = null, next = null;
    $$(STEP, rail).forEach(function (b) { var n = dirOf(b); if (n < 0) prev = b; else if (n > 0) next = b; });
    if (!list || !nav || !bar || !thumb || !prev || !next || !firstRail(rail)) return;

    /* Phones: the row starts on the first card. If the browser or Back restores it somewhere in the
       middle, put it back, unless the shopper has already touched the row. */
    var touched = false;
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (t) { rail.addEventListener(t, function () { touched = true; }, { passive: true }); });
    function toStart() { if (!touched && rail.isConnected && list.scrollLeft > 2 && PHONE.matches) list.scrollLeft = 0; }
    if (d.readyState === 'complete') toStart(); else window.addEventListener('load', toStart);
    window.addEventListener('pageshow', function (e) { if (e.persisted) { touched = false; toStart(); } });

    function cards() { return Array.prototype.filter.call(list.children, function (k) { return k.classList.contains('rcc-card') && k.getClientRects().length > 0; }); }
    /* a card's left edge in the list's scroll coordinates (offsetLeft without needing a positioned list) */
    function offL(c) { return c.getBoundingClientRect().left - list.getBoundingClientRect().left - list.clientLeft + list.scrollLeft; }
    var frame = 0, ro = null, mo = null;
    function max() { return list.scrollWidth - list.clientWidth; }
    function thumbWidth() { return Math.max(40, bar.clientWidth * list.clientWidth / (list.scrollWidth || 1)); }
    function alive() { if (rail.isConnected) return true; if (ro) ro.disconnect(); if (mo) mo.disconnect(); ro = mo = null; return false; }
    function update() {
      frame = 0;
      if (!alive()) return;
      var m = max();
      list.classList.toggle('is-fit', m <= 2);
      nav.hidden = m <= 2;
      if (nav.hidden) return;
      var w = thumbWidth();
      var f = Math.min(1, Math.max(0, list.scrollLeft / m));
      thumb.style.width = w + 'px';
      thumb.style.transform = 'translateX(' + (f * (bar.clientWidth - w)) + 'px)';
      bar.setAttribute('aria-valuenow', Math.round(f * 100));
      prev.setAttribute('aria-disabled', list.scrollLeft <= 2 ? 'true' : 'false');
      next.setAttribute('aria-disabled', list.scrollLeft >= m - 2 ? 'true' : 'false');
    }
    function queue() { if (!frame) frame = requestAnimationFrame(update); }
    function cardStep() { var c = cards()[0]; return c ? c.offsetWidth + (parseFloat(getComputedStyle(list).columnGap) || 12) : list.clientWidth * 0.8; }

    /* Dragging the handle moves the row one to one. Snapping is paused while dragging so the row
       follows the pointer, then turned back on so it settles on the nearest card. */
    var dragging = false, startX = 0, startLeft = 0;
    thumb.addEventListener('pointerdown', function (e) {
      dragging = true; startX = e.clientX; startLeft = list.scrollLeft;
      bar.classList.add('is-dragging');
      list.style.scrollSnapType = 'none';
      try { thumb.setPointerCapture(e.pointerId); } catch (x) {}
      e.preventDefault(); e.stopPropagation();
    });
    thumb.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var travel = bar.clientWidth - thumbWidth();
      if (travel > 0) list.scrollLeft = startLeft + (e.clientX - startX) * max() / travel;
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      bar.classList.remove('is-dragging');
      list.style.scrollSnapType = '';
    }
    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);

    /* a tap on the track jumps the handle's middle to that spot */
    bar.addEventListener('pointerdown', function (e) {
      if (e.target === thumb) return;
      var r = bar.getBoundingClientRect(), w = thumbWidth(), travel = r.width - w;
      if (travel <= 0) return;
      var f = Math.min(1, Math.max(0, (e.clientX - r.left - w / 2) / travel));
      list.scrollTo({ left: f * max(), behavior: 'smooth' });
    });
    bar.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        list.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * cardStep(), behavior: 'smooth' });
        e.preventDefault();
      }
    });

    /* Phones page two cards per tap: a pair rests with its first card at the left edge. Rest positions
       are compared rather than card middles, or the first tap would skip a card. */
    function per() { return PHONE.matches ? 2 : 1; }
    function restLeft(c) {
      if (PHONE.matches) return Math.max(0, Math.min(max(), offL(c) - (parseFloat(getComputedStyle(list).paddingLeft) || 0)));
      return Math.max(0, Math.min(max(), offL(c) + c.offsetWidth / 2 - list.clientWidth / 2));
    }
    function current(dir) {
      var cs = cards(), x = list.scrollLeft, best = 0, gap = Infinity;
      for (var i = 0; i < cs.length; i += per()) {
        var dd = Math.abs(restLeft(cs[i]) - x);
        if (dd < gap - 1 || (dir > 0 && dd <= gap + 1)) { gap = Math.min(gap, dd); best = i; }
      }
      return best;
    }
    function goTo(i) {
      var cs = cards(); if (!cs.length) return;
      i = Math.max(0, Math.min(cs.length - 1, i));
      list.scrollTo({ left: restLeft(cs[i]), behavior: 'smooth' });
    }
    /* Desktop: the arrows sit either side of the bar and move a whole screen of cards */
    function pageStep() {
      var cs = cards();
      if (!cs.length) return list.clientWidth * 0.8;
      var pitch = cs.length > 1 ? offL(cs[1]) - offL(cs[0]) : cs[0].offsetWidth;
      if (pitch <= 0) pitch = cs[0].offsetWidth || list.clientWidth * 0.8;
      var cls = getComputedStyle(list), gapPx = pitch - cs[0].offsetWidth;
      var view = list.clientWidth - (parseFloat(cls.paddingLeft) || 0) - (parseFloat(cls.paddingRight) || 0);
      return Math.max(1, Math.floor((view + gapPx + 2) / pitch)) * pitch;
    }
    /* quick double clicks count from the page (or card) already on its way */
    var deskTarget = -1, deskTimer = 0;
    function deskGo(dir) {
      var mx = list.scrollWidth - list.clientWidth;
      var from = deskTarget >= 0 ? deskTarget : list.scrollLeft;
      deskTarget = Math.max(0, Math.min(mx, from + dir * pageStep()));
      clearTimeout(deskTimer);
      deskTimer = setTimeout(function () { deskTarget = -1; }, 700);
      list.scrollTo({ left: deskTarget, behavior: 'smooth' });
    }
    var target = -1, targetTimer = 0;
    function clearTarget() { target = -1; }
    list.addEventListener('scrollend', function () { deskTarget = -1; clearTarget(); });
    [prev, next].forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        var dir = dirOf(btn);
        if (WIDE.matches) { deskGo(dir); return; }
        var n = cards().length; if (!n) return;
        var base = target >= 0 ? target : current(dir);
        target = Math.max(0, Math.min(n - 1, base + dir * per()));
        clearTimeout(targetTimer);
        targetTimer = setTimeout(clearTarget, 700);
        goTo(target);
      });
    });

    list.addEventListener('scroll', queue, { passive: true });
    if (window.ResizeObserver) { ro = new ResizeObserver(queue); ro.observe(list); ro.observe(bar); }
    else window.addEventListener('resize', queue);
    if (window.MutationObserver) { mo = new MutationObserver(queue); mo.observe(list, { childList: true }); }
    update();
    setTimeout(update, 400);
  }

  /* find lists, rails and hover photos under a node (the page, or a section the theme editor re-rendered) */
  function scan(n) {
    n = n || d;
    sheets();
    var self = n !== d && n.matches;
    (self && n.matches('.rc-cards') ? [n] : []).concat($$('.rc-cards', n)).forEach(watchList);
    (self && n.matches('[data-rcx-rail]') ? [n] : []).concat($$('[data-rcx-rail]', n)).forEach(initRail);
    watchHovers(n);
  }
  RCX.scan = scan;

  try { scan(d); } catch (e) { if (window.console) console.error('rc-card', e); }
  try { returnToast(); } catch (e) {}
  if (d.readyState === 'complete') startHovers(); else window.addEventListener('load', startHovers);
  if (FINE.addEventListener) FINE.addEventListener('change', function () { if (d.readyState === 'complete') startHovers(); });
  d.addEventListener('shopify:section:load', function (e) { try { scan(e.target); } catch (x) {} });
})();
